var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargingSessionActiveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3505 19.68C17.8005 21.09 16.4605 22 14.9505 22H9.05047C7.53047 22 6.20047 21.09 5.65047 19.68C5.10047 18.26 5.48047 16.69 6.60047 15.67L10.6505 12H13.3605L17.4005 15.67C18.5205 16.69 18.8905 18.26 18.3505 19.68Z",
    fill: "#1A2128"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.82 18.1403H10.18C9.8 18.1403 9.5 17.8303 9.5 17.4603C9.5 17.0803 9.81 16.7803 10.18 16.7803H13.82C14.2 16.7803 14.5 17.0903 14.5 17.4603C14.5 17.8303 14.19 18.1403 13.82 18.1403Z",
    fill: "#1A2128"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3497 4.32C17.7997 2.91 16.4597 2 14.9497 2H9.04967C7.53967 2 6.19967 2.91 5.64967 4.32C5.10967 5.74 5.47967 7.31 6.60967 8.33L10.6497 12H13.3597L17.3997 8.33C18.5197 7.31 18.8897 5.74 18.3497 4.32ZM13.8197 7.23H10.1797C9.79967 7.23 9.49967 6.92 9.49967 6.55C9.49967 6.18 9.80967 5.87 10.1797 5.87H13.8197C14.1997 5.87 14.4997 6.18 14.4997 6.55C14.4997 6.92 14.1897 7.23 13.8197 7.23Z",
    fill: "#1A2128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingSessionActiveDark);
export default __webpack_public_path__ + "static/media/charging-session-active-dark.30bf4bbffe69ed6a3f7d53bf0099680e.svg";
export { ForwardRef as ReactComponent };